import { IRole, RoleId } from '../types';

export const roles: Record<RoleId, IRole> = {
    resellerAdmin: { id: 'resellerAdmin', name: 'Reseller Admin', cognitoGroup: 'ResellerAdminsUserGroup' },
    resellerCreator: { id: 'resellerCreator', name: 'Reseller Creator', cognitoGroup: 'ResellerCreatorsUserGroup' },
    resellerViewer: { id: 'resellerViewer', name: 'Reseller Viewer', cognitoGroup: 'ResellerViewersUserGroup' },
    claimCreator: { id: 'claimCreator', name: 'Cliams Creator', cognitoGroup: 'ClaimsCreatorsUserGroup' },
    claimViewer: { id: 'claimViewer', name: 'Claims Viewer', cognitoGroup: 'ClaimsViewersUserGroup' },
    pdfClaimAdmin: { id: 'pdfClaimAdmin', name: 'PDF Claims Admin', cognitoGroup: 'PdfClaimsAdminsUserGroup' },
    pdfClaimCreator: { id: 'pdfClaimCreator', name: 'PDF Claims Creator', cognitoGroup: 'PdfClaimsCreatorsUserGroup' },
    amazonAdmin: { id: 'amazonAdmin', name: 'Amazon Admin', cognitoGroup: 'AmazonAdminsUserGroup' },
    amazonCreator: { id: 'amazonCreator', name: 'Amazon Creator', cognitoGroup: 'AmazonCreatorsUserGroup' },
    certificateAdmin: { id: 'certificateAdmin', name: 'Certificate Admin', cognitoGroup: 'CertificateAdminsUserGroup' },
    poAdmin: { id: 'poAdmin', name: 'Purchase Order Admin', cognitoGroup: 'POAdminsUserGroup' },
    poViewer: { id: 'poViewer', name: 'Purchase Order Viewer', cognitoGroup: 'POViewersUserGroup' },
    poEditor: {
        id: 'poEditor',
        name: 'Purchase Order Editor',
        cognitoGroup: 'POEditorsUserGroup',
    },
    unauthenticatedUser: { id: 'unauthenticatedUser', name: 'Unauthenticated User' },
    authenticatedUser: { id: 'authenticatedUser', name: 'Authenticated User' },
};

export const INTERNAL_ROLE_IDS = ['amazonAdmin', 'amazonCreator'];
export const PDF_CLAIMS_ROLES = ['pdfClaimAdmin', 'pdfClaimCreator', 'amazonAdmin'];
export const PO_CREATOR_ROLES = ['poAdmin', 'poEditor', 'amazonAdmin'];

// Display order for role checkboxes: highest power first, grouped by domain
export const ROLE_DISPLAY_ORDER: RoleId[] = [
    'amazonAdmin',
    'amazonCreator',
    'resellerAdmin',
    'resellerCreator',
    'resellerViewer',
    'claimCreator',
    'claimViewer',
    'pdfClaimAdmin',
    'pdfClaimCreator',
    'poAdmin',
    'poViewer',
    'poEditor',
    'certificateAdmin',
];
